export const DATA_TEST_IDS = {
  ROOT: (id: string) => `mediafile_item_root_${id}`,
  HEADER: (id: string) => `mediafile_item_header_${id}`,
  HEADER_BODY: (id: string) => `mediafile_item_header_body_${id}`,
  LEADING: (id: string) => `mediafile_item_leading_${id}`,
  TITLE: (id: string) => `mediafile_item_title_${id}`,
  METADATA: (id: string) => `mediafile_item_metadata_${id}`,
  STATUS: (id: string) => `mediafile_item_status_${id}`,
  FIELDS: (id: string) => `mediafile_item_fields_${id}`,
  SETTINGS_TRIGGER: (id: string) => `mediafile_item_settings_trigger_${encodeURIComponent(id)}`,
  SETTINGS_TRIGGER_BY_TITLE: (title: string) => `mediafile_item_settings_trigger_${title}`,
  SETTINGS_PANEL: (id: string) => `mediafile_item_settings_panel_${id}`,
  ACTIONS: (id: string) => `mediafile_item_actions_${id}`,
  ACTION: (id: string, actionId: string) =>
    `mediafile_item_action_${encodeURIComponent(id)}_${encodeURIComponent(actionId)}`,
};
